import { ServiceRegisterService } from '../../services/service-register';
import { ServiceRegister } from './../../models/service-register';
import { ContactService } from './../../services/contact.service.';
import { Contact } from './../../models/contact';
import { Services } from './../../models/services';
import { ServicesService } from './../../services/services.service';
import { Component, ElementRef, OnInit, ɵConsole } from '@angular/core';
import Swal from 'sweetalert2'
import { filter } from 'rxjs/operators';
import * as siteSource from 'src/app/site/sitesource';
@Component({
  selector: 'app-personel-consultant',
  templateUrl: './personel-consultant.component.html',
  styleUrls: ['./personel-consultant.component.scss']
})
export class PersonelConsultantComponent implements OnInit {

  service:Services[];
  contact:Contact=new Contact();
  status=0;
  selectedService:Services;
  IsFree=false;
  Agreement=false;
  servicetry=80;
  serviceRegistration:ServiceRegister=new ServiceRegister();
  taxOffices:ExternalModel[];
  city:ExternalModel[];
  town:ExternalModel[];
  taxCompany;
  interval;
  interval2;
  buyButtonActive=true;
  buttonText="Satın Al";
  buttonCounter=60;
  constructor(private services:ServicesService,private contactService:ContactService,private serviceRegisterService:ServiceRegisterService) {
        siteSource.showLoading();
    this.serviceRegistration.serviceName="";
    this.serviceRegistration.price=0;
    this.serviceRegistration.quantity=1;
    this.serviceRegistration.isCompany=false;
    services.getSiteServices().subscribe((data)=>{
      this.service=data;console.log(data)
      setTimeout(() => {
        siteSource.hideLoading();
      }, 500);
    })
    serviceRegisterService.getTaxOffices().subscribe((data)=>{console.log(data)
      this.taxOffices=data;
    })
    serviceRegisterService.getCity().subscribe((data)=>{console.log(data)
      this.city=data;
    })
   }
checkServicePrice(id):string{
  if(this.service)
    return this.service.filter((f)=>f.id==id)[0]?.price>0?" Satın al":" Görüşme Talep Et"
  return "Detay"
}
  ngOnInit() {
  }
  sendContact(){
    if(!this.contact.checkData()){
      Swal.fire("Eksik Bilgi", "Lütfen Eksik Kısım Bırakmayınız.", 'warning')
      return;
    }
    this.contactService.saveContact(this.contact).then((res)=>{

        if(res)
        {
           this.contact=new Contact();
           siteSource.closeModal();
           Swal.fire("İşlem Başarılı", "Mesajınız başarılı bir şekilde alınmıştır. En kısa sürede size ulaşacağız.", 'success')
        }
        else
        Swal.fire("Hata", "İşlem sırasında bir sorun ile karşılaşıldı. Tekrar deneyin veya telefon üzerinden iletişime geçin.", 'error')
      }).catch((err)=>{Swal.fire("Hata", "İşlem sırasında bir sorun ile karşılaşıldı. Tekrar deneyin veya telefon üzerinden iletişime geçin.", 'error')})
  }
  changeService(id){
    console.log(this.service)
    if(!this.service){
      if(this.servicetry!=0) {this.servicetry--;return;}
       Swal.fire("Hata", "Sunucuya bağlanılamadı. Tekrar deneyin veya telefon üzerinden iletişime geçin.", 'error').then(()=>{
        window.location.reload();
        return;
       })
    }
    this.status=0;
      this.Agreement=false;
      this.selectedService=this.service.filter(f=>f.id==id)[0];
      this.IsFree=this.selectedService?.price==0??true;
      if(this.selectedService.educationDate.length>0)
        this.ChangeDate(this.selectedService.educationDate[0].id)
      this.contact.subject=this.selectedService.name+" - Görüşme Talebi";
      if(!this.IsFree){
        this.serviceRegistration.quantity=1;
        this.serviceRegistration.serviceId=id;
        this.serviceRegistration.serviceName=this.selectedService.name;
        this.serviceRegistration.price=this.selectedService.price;
      }
      console.log(this.selectedService)
  }
  sendRegisteration(){
    if(this.taxCompany)
    this.serviceRegistration.taxOffice=this.taxCompany.name;
    if(!this.checkAgreement()) return;
    if(this.serviceRegistration.quantity<1)this.serviceRegistration.quantity=1;
    if(!this.serviceRegistration.checkRegistration()){
      if(this.serviceRegistration.isCompany)
         Swal.fire("Eksik Bilgi", "Lütfen Ad Soyad, Mail, Telefon ve Fatura Bilgilerindeki kısımlarını doldurunuz.", 'warning')
      else
         Swal.fire("Eksik Bilgi", "Lütfen Ad Soyad, Mail, Telefon ve Fatura Bilgilerindeki  kısımlarını doldurunuz.", 'warning')
      return;
    }
    if(this.serviceRegistration.serviceId==0){
      Swal.fire("Hizmet Bulunamadı", "Hizmet Seçilemedi. Lütfen işlem yaptığınız ekranı kapatıp tekrar açınız.", 'warning')
      return;
    }

    if(this.selectedService.educationDate.length>0)
      this.serviceRegistration.note= this.serviceRegistration.calendarId!=0?this.selectedService.educationDate.filter(f=>f.id==this.serviceRegistration.calendarId)[0].date+ "Seçimi ile Kayıt Açılmıştır. Not:"+this.serviceRegistration.note:"Eğitim Tarihi seçilmemiştir. Not:"+this.serviceRegistration.note;
  this.buyButtonActive=false;
  this.serviceRegisterService.saveServiceRegister(this.serviceRegistration).then((res)=>{
       console.log(res)
        if(res.iFrame){
          console.log(res)
        window.open(res.iFrame, "_blank");
        this.checkPayment(res.orderNo);
        }else{
           Swal.fire("Hata", res, 'error')
        }
      }).catch((err)=>{console.log(err);Swal.fire("Hata", "İşlem sırasında bir sorun ile karşılaşıldı. Tekrar deneyin veya telefon üzerinden iletişime geçin.", 'error');  this.buyButtonActive=true;})
  }
  ChangeQuantity(event){
    this.serviceRegistration.quantity=event;
  }
  ChangeDate(event){
    this.serviceRegistration.calendarId=event;
  }
  CompanyChange(stat){
    this.serviceRegistration.isCompany=stat;
    this.serviceRegistration.taxNumberOrTC="";
  }
  checkAgreement():boolean{
    if(this.Agreement)
      return true;
    Swal.fire("Sözleşme Onayı", "Lütfen sözleşmeyi kabul ediniz.", 'warning')
    return false;
  }
checkPayment(orderNo){
  this.interval2 = setInterval(() => {
    if(this.buttonCounter==0){
      clearInterval(this.interval2);
      this.buyButtonActive=true;
      this.buttonText="Satın Al";
      this.buttonCounter=60;
    }else{
      this.buttonCounter--;
      this.buttonText="Ödeme İşlemi Bekleniyor ("+this.buttonCounter+")";
    }

    },1000)
  this.buyButtonActive=false;
  clearInterval(this.interval);
  this.interval = setInterval(() => {
    this.serviceRegisterService.CheckPayment(orderNo).then((res2)=>{
      console.log(res2)
        if(res2!=-1 && res2!=1)
          return;
        clearInterval(this.interval);
        if(res2==-1)
          Swal.fire("Ödeme Hatası", 'Ödeme İptal Edildi.', 'error')
        else if(res2==1)
        {
          Swal.fire("Ödeme Başarılı", 'Ödemeniz Başarılı Bir Şekilde Gerçekleşmiştir. Aldığınız Hizmet İle İlgili Bilgilendirileceksiniz.', 'success').then(()=>{
            window.location.reload();
          })
        }
        clearInterval(this.interval2);
        this.buyButtonActive=true;
        this.buttonCounter=60;
        this.buttonText="Satın Al";

      })
  },2000)
}
  checkRegistration(){
    if(!this.Agreement)
    {
      Swal.fire("Dikkat", "İşleme devam etmek için .", 'error')
    }
  }
  ChangeCity(event){

    this.serviceRegistration.cityId=event;
    if(event!=0)
      this.serviceRegisterService.getTown(this.serviceRegistration.cityId).subscribe((res)=>{
        this.town=res;
        this.ChangeCounty(res[0].id)
      })
    else
      {this.town=[];this.serviceRegistration.townId=0}
  }
  ChangeCounty(event){
    this.serviceRegistration.townId=event;
  }
  onChangeSearch(val: string) {
    this.taxCompany=val;
  }
}
export class ExternalModel{
  id:number;
  name:string;
  constructor(id,name) {
    this.id=id;this.name=name;
  }
}
